import { makeStyles } from "@material-ui/core";

export const css = makeStyles(() => ({
    h2: {
        fontSize: "20px",
        fontWeight: "bold",
        lineHeight: "20px",
    },
}));
